import React, { PureComponent } from 'react'
import { Paper, ListItem, Grid, MenuItem, Typography } from '@material-ui/core'

// constants
import { getUsStates, usStates } from '../../utils/constants'

// api hits
import { uploadCompanyLogo } from '../../api/assets'

// utils
import { hasAccess } from '../../utils/api'

// local components
import EditActionComponent from '../common/EditActionComponent'

import { EditableTextField, EditableSelect, EditableSwitch } from '../common/EditableComponents'
import { EditableColorPicker, ColorSwatch } from '../common/ColorPicker'
import ReactPhoneInput from '../common/ReactPhoneInput'
import { openErrorMessage } from '../../actions/message'

const statesList = getUsStates()

class ReportingInfo extends PureComponent {
  onChange = (key) => (e) => {
    const value = e.target.value
    this.props.onChange(key, value)
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { editMode = false, data = {} } = this.props

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {hasAccess() ? (
              <div className="pull-right margin-bottom-small">
                <EditActionComponent
                  onSave={this.onSave}
                  onCancel={this.onCancel}
                  onEdit={this.props.enableEdit}
                  editMode={editMode}
                />
              </div>
            ) : (
              <div className="pull-right margin-bottom-small"></div>
            )}
          </Grid>
        </Grid>
        <Grid className="reportingInfo" container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Dashboard sales calculations
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSelect
                      value={data.dashboardSalesCalculation}
                      onChange={this.onChange('dashboardSalesCalculation')}
                      valueToRender={`${
                        data.dashboardSalesCalculation == 'NET_SALES'
                          ? 'Net Sales'
                          : 'Gross receipts'
                      }`}
                      editMode={editMode}
                    >
                      <MenuItem value="NET_SALES">Net sales</MenuItem>
                      <MenuItem value="GROSS_SALES">Gross receipts</MenuItem>
                    </EditableSelect>
                  </Grid>
                </Grid>
              </ListItem>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default ReportingInfo



// WEBPACK FOOTER //
// ./src/components/ReportingInfo/index.js